// Shared Groq model for all summarization
export const GROQ_MODEL = "llama-3.1-8b-instant";
// src/services/groq.js

/**
 * Send a prompt to the Groq LLM summarizer endpoint and return the summary.
 * @param {string} prompt - The prompt to summarize (should be a stringified object or text)
 * @returns {Promise<string>} - The summary response from Groq
 */

/**
 * Send a prompt to the Groq LLM endpoint with customizable parameters and return the summary.
 * @param {string} prompt - The prompt to send (stringified object or text)
 * @param {Object} options - LLM parameters (model, messages, temperature, max_completion_tokens, top_p, stream, stop)
 * @returns {Promise<string>} - The summary/response from Groq
 */
// (No import needed, GROQ_MODEL is defined above)
export async function summarizeWithGroq(prompt, options = {}) {
  const {
    model = GROQ_MODEL,
    messages,
    temperature = 0.3,
    max_completion_tokens = 1024,
    top_p = 1,
    stream = false,
    stop = null
  } = options;

  const body = {
    model,
    messages,
    temperature,
    max_completion_tokens,
    top_p,
    stream
  };
  if (stop !== null) body.stop = stop;

  const res = await fetch("https://bylolucjhzsbbouoalah.functions.supabase.co/groq-chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  const data = await res.json();
  return data?.choices?.[0]?.message?.content || "No summary returned.";
}
